import React, { Component } from 'react'
import * as DashboardError404Constant from './ErrorsAdminConstant'
import DashboardCleanersAdminHeader from '../../Shared/DashboardCleanersAdminHeader/DashboardCleanersAdminHeader'
import '../../../CSS/dashboard.css'

class CleanersAdminDashboardError404 extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <DashboardCleanersAdminHeader />
                <div className="ErrorDashboard">
                    <p>{DashboardError404Constant.Error404DashboardParagraph}</p>
                    <p>{DashboardError404Constant.Error404DashboardParagraphPlease}</p>
                </div>
            </div>
        )
    }
}

export default CleanersAdminDashboardError404;